import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "g-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formconfig, (itemconfig, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemconfig.data, (item) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.GetControlType(item.control_type, item)), {
            key: item.field + itemconfig.name,
            item: item,
            value: _ctx.GetValue(item.field),
            onInput: ($event: any) => (_ctx.SetValue(item.field, $event)),
            onValuechange: ($event: any) => (_ctx.SetValue( item.field, $event))
          }, null, 40, ["item", "value", "onInput", "onValuechange"]))
        }), 128)),
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "form-components",
          style: {"margin":"0"}
        }, null, -1))
      ]))
    }), 128))
  ]))
}